import StripeActivateAccountPage from './StripeActivateAccountPage'

export default StripeActivateAccountPage
